import type { TemplateCatalog } from "@/types/domain"
import { demoCatalogItemTypes } from "@/data/demo-catalog-data"

const createdAt = "2026-06-01T12:00:00.000Z"

export const demoTemplateCatalog: TemplateCatalog = {
  imprints: [
    { id: "imprint-filosofia", code: "filosofia", skuSuffix: "FIL", name: "Clube de Filosofia", niche: "Filosofia", tagline: "A filosofia nasce do espanto.", description: "Clássicos e obras contemporâneas para ampliar o repertório filosófico.", instagramHandle: "logos.editora", websiteUrl: "https://clubedefilosofia.com", country: "Brasil", backgroundColor: "#FDBD03", textColor: "#000000", kind: "BARCA", active: true },
    { id: "imprint-literatura", code: "literatura", skuSuffix: "LIT", name: "Clube de Literatura", description: "Edições literárias selecionadas para leitores curiosos.", country: "Brasil", kind: "BARCA", active: true },
    { id: "imprint-ciencias", code: "ciencias", skuSuffix: "CIE", name: "Clube de Ciências", description: "Ciência e divulgação científica em edições acessíveis.", country: "Brasil", kind: "WHITE_LABEL", active: true },
  ],
  itemTypes: demoCatalogItemTypes,
  kitTemplates: [
    {
      id: "kit-filosofia",
      name: "Box mensal padrão",
      imprintId: "imprint-filosofia",
      imprintName: "Clube de Filosofia",
      items: [
          { id: "kit-item-1", itemTypeId: "type-book", itemTypeCode: "BOOK", itemTypeName: "Livro", variantId: "variant-livro-hard-cover-141x216", variantName: "Livro capa dura 141x216 mm", defaultName: "Livro principal", position: 1 },
          { id: "kit-item-2", itemTypeId: "type-booklet", itemTypeCode: "BOOKLET", itemTypeName: "Livreto", variantId: "variant-livro-booklet-135x210", variantName: "Livreto brochura 135x210 mm", defaultName: "Livreto de auxílio à leitura", position: 2 },
          { id: "kit-item-3", itemTypeId: "type-bookmark", itemTypeCode: "BOOKMARK", itemTypeName: "Marca-página", variantId: "variant-marca-pagina-50x200", variantName: "Marca-página 50x200 mm", defaultName: "Marca-página", position: 3 },
          { id: "kit-item-4", itemTypeId: "type-packaging", itemTypeCode: "PACKAGING", itemTypeName: "Caixa personalizada", variantId: "variant-caixa-personalizada", variantName: "Caixa personalizada", defaultName: "Papel de embrulho", position: 4 },
      ],
    },
  ],
  pipelineTemplates: [
    {
      id: "pipeline-filosofia",
      name: "Publicação mensal",
      imprintId: "imprint-filosofia",
      imprintName: "Clube de Filosofia",
      active: true,
      hasProductionRuns: true,
      canDelete: false,
      versions: [{
        id: "pipeline-filosofia-v1",
        version: 1,
        publishedAt: createdAt,
        createdAt,
        stages: [
          {
            id: "stage-briefing",
            name: "Briefing",
            shortName: "Briefing",
            position: 1,
            editorialFunction: "EDITOR_IN_CHIEF",
            applicableItemTypeIds: ["type-book", "type-booklet", "type-bookmark", "type-packaging"],
            checklists: [{ id: "check-briefing", label: "Briefing validado pelo responsável", required: false, itemTypeIds: [], position: 1 }],
          },
          {
            id: "stage-editorial",
            name: "Editorial",
            shortName: "Editorial",
            position: 2,
            editorialFunction: "TEXT_REVIEWER",
            applicableItemTypeIds: ["type-book", "type-booklet"],
            checklists: [{ id: "check-text", label: "Texto final revisado", required: false, itemTypeIds: ["type-book"], position: 1 }],
          },
          {
            id: "stage-design",
            name: "Design",
            shortName: "Design",
            position: 3,
            editorialFunction: "DESIGNER",
            applicableItemTypeIds: ["type-book", "type-booklet", "type-bookmark", "type-packaging"],
            checklists: [{ id: "check-art", label: "Arquivo fechado nas especificações", required: false, itemTypeIds: [], position: 1 }],
          },
        ],
        gates: [
          { id: "gate-kit", label: "Todos os componentes conferidos como um box", required: false, position: 1 },
          { id: "gate-shipping", label: "Dados de expedição liberados", required: false, position: 2 },
        ],
      }],
    },
  ],
}
